module.exports = __webpack_public_path__ + "static/media/sa7.94750f4a.jpg";